function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.062,20.131a.251.251,0,0,0-.422.128L11.012,23.4a.5.5,0,0,0,.49.6.473.473,0,0,0,.1-.01l3.143-.629a.25.25,0,0,0,.127-.422Z",
  transform: "translate(-0.822)",
  fill: "#ff7e00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.228,11.765a2.62,2.62,0,0,0-3.7,0l-6.5,6.5a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.707,0l6.5-6.5A2.621,2.621,0,0,0,23.228,11.765Z",
  transform: "translate(-1.499)",
  fill: "#ff7e00"
}), /*#__PURE__*/React.createElement("rect", {
  width: 11.5,
  height: 4.5,
  rx: 0.5,
  transform: "translate(3.5 3.5)",
  fill: "#ffb238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.123,9.5H4a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5H9.837a.5.5,0,0,0,.481-.637l-1.714-6A.5.5,0,0,0,8.123,9.5Z",
  fill: "#ffb238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.433,16.5a.577.577,0,0,0,.406-.167l1.868-1.869A1,1,0,0,0,15,13.757V10a.5.5,0,0,0-.5-.5H10.663a.5.5,0,0,0-.481.638l1.7,5.946a.573.573,0,0,0,.551.416Z",
  transform: "translate(-0.795)",
  fill: "#ffb238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.577,18H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2H16a.5.5,0,0,1,.5.5v9.567a.25.25,0,0,0,.427.177l1.279-1.279a1,1,0,0,0,.293-.707V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V18a2,2,0,0,0,2,2H9.751a.5.5,0,0,0,.49-.4l.048-.241a2.009,2.009,0,0,1,.477-.943A.251.251,0,0,0,10.577,18Z",
  fill: "#ffb238"
})));

var SvgUxDesigner = function SvgUxDesigner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.5,
    height: 24,
    viewBox: "0 0 22.5 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUxDesigner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ux_designer.24bf1bd1.svg";
export { ForwardRef as ReactComponent };